import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import RepairTypeModel from '@/models/RepairTypeModel'

// -----------------------------------------------------------------------------

const state = {
    repairTypes: {},
    isLoading: false,
}

const getters = {
    getRepairTypes: state => {
        return _orderBy(state.repairTypes, ['id'], ['asc'])
    },

    getRepairType: state => repairTypeId => {
        return state.repairTypes[repairTypeId] || null
    },
}

const mutations = {
    setRepairTypes(state, payload) {
        state.repairTypes = {}

        _forEach(payload, item => {
            const RepairType = new RepairTypeModel(item)

            Vue.set(state.repairTypes, RepairType.id, RepairType)
        })
    },

    setRepairType(state, payload) {
        const RepairType = new RepairTypeModel(payload)

        Vue.set(state.repairTypes, RepairType.id, RepairType)
    },

    setIsLoading(state, payload) {
        state.isLoading = !!payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
